import { withHex } from '../../utils';
export function openColorPicker(SDKAdapter, _a) {
    var value = _a.value, onChange = _a.onChange, onSiteColorsChange = _a.onSiteColorsChange, position = _a.position;
    var HORIZONTAL_OFFSET = 6;
    SDKAdapter.openColorPicker({
        color: value.name || withHex(value.value),
        left: position.right + HORIZONTAL_OFFSET,
        top: position.top,
    }, function (values) {
        if (values.paletteChange && values.palette) {
            onSiteColorsChange(values.palette);
        }
        /**
         * NOTE: that `values.colorParam`  may be without value, only with `themeName`
         * This is wrong behaviour for component
         * but if use with StylesContext, it will be normalized there
         */
        if (values.colorParam) {
            onChange({
                value: values.colorParam.value,
                opacity: value.opacity,
                name: values.colorParam.themeName,
            });
        }
    });
}
//# sourceMappingURL=openColorPicker.js.map